import React from 'react';
import { AlphabetOptions } from '../../utils/AlphabetOptions';
import CatalogTableC from '../../components/Catalogs/CatalogTableC';
import useDataLoader2 from '../../hooks/useDataLoader2';
import { UsePracticeIndustryList } from '../../hooks/Catalogs/usePracticeIndustry';
import { UseFirmList, firmType } from '../../hooks/Catalogs/useFirm';
import ShapeEdit from '../../components/Atomos/Icons/ShapeEdit';
import PaginatedTable from '../../components/Organismos/Table/PaginatedTable';
import { formatTimeSpanToString } from '../../utils/functions';
import { defaultPageSize } from '../../utils/const';
import Filters, { IFilterData } from '../../components/Catalogs/Filters/Filters';
import PersistentLink from '../../components/Moleculas/PersistentLink';
import { exportAllDataLoader2 } from "../../utils/exportAllDataLoader2";

const AreaOfPractice: React.FC = ({ ...props }) => {
  const { practiceIndustryData: practiceIndustries } = UsePracticeIndustryList();
  const { firmData } = UseFirmList(firmType.member);
  const fields = [
    'id', 
    'legacyId',
    'name', 
    'isMapped', 
    'isIgnored', 
    'isTargeted',   
    'firms',   
    'firmNames',
    'practiceIndustries',
    'practiceIndustryNames',
    'createdDate',
    'offices',
  ]
  const endpoint = '/AreaOfPractice';
  const { 
    data, 
    totalCount, 
    fetchData, 
    setFilter, 
    sort, 
    setSort, 
    pagination, 
    setPagination,
    filter,
    inputFilters,
    setInputFilters
  } = useDataLoader2<any>({
    endpoint,
    defaultPageSize,
    fields,
    defaultSorting: { field: "name", order: "asc" },
  });

  const columnsDef = React.useMemo(() => [
    { id: 'count', header: '#', enableSorting: false },
    { id: 'name', header: 'Name' },
    { id: 'isMapped', header: 'Is Mapped' },
    { id: 'isIgnored', header: 'Is Ignored' },
    { id: 'isTargeted', header: 'Is Targeted' },
    { id: 'firms', header: 'Firms' },
    { id: 'practiceIndustries', header: 'Practice Industries' },
    { id: 'createdDate', header: 'Created Date' },
    {
      id: 'edit',
      header: 'Edit',
      enableSorting: false,
      cell: ({ row, rowIndex }: { rowIndex: number; row: any; value: any }) => (
        <PersistentLink
          className="edit"
          to={`Edit/${row.id}`}
          state={data[rowIndex]}
          persistingData={{
            pagination,
            sort,
            filter, 
            inputFilters, 
          }}
        >
          Edit{" "}
          <div className="editsvg">
            <ShapeEdit />
          </div>{" "}
        </PersistentLink>
      ),
    },
  ], [pagination.pageIndex, pagination.pageSize, sort, filter, inputFilters, data]);

  const formatData = (data: any[]) => {
    const formattedData = data.map((d: any) => {

      return {
        ...d,
        isMapped: d.isMapped ? 'Yes' : 'No',
        isIgnored: d.isIgnored ? 'Yes' : 'No',
        isTargeted: d.isTargeted ? 'Yes' : 'No',
        firms: d.firmNames,
        practiceIndustries: d.practiceIndustryNames,
        createdDate: formatTimeSpanToString(d.createdDate),
      };
    });
    return formattedData;
  };

  const filtersData: IFilterData[] = React.useMemo(() => [
    {
      name: "Name",
      type: "text",
      comparison: "CONTAINS",
    },
    {
      name: "Firm",
      fieldName: "firms",
      objectData: firmData?.map((f: any) => ({id: f.id, name:f.name})) || [],
    },
    {
      name: "Practice Industry",
      fieldName: "practiceIndustries",
      objectData: practiceIndustries?.map((p: any) => ({id: p.id, name: p.name})) || [],
    },
    {
      name: "Initial",
      fieldName: "firms",
      objectData: AlphabetOptions || [],
    },
  ],[firmData, practiceIndustries])

  return (
    <>
        <CatalogTableC
          title="Areas Of Practice Catalog"
          catalogName="AREAS OF PRACTICE"
          catalogShortName='Area Of Practice'
          route="AreaOfPractice"
          totalCount={totalCount}
        >
          <Filters
            filtersData={filtersData} 
            filterValues={inputFilters}
            setFilterValues={setInputFilters} 
            Search={() => fetchData()}
            clearSelections={() => fetchData(true)}
            setValueForQuery={setFilter}
          />
          <PaginatedTable
            data={data || []}
            columnsDef={columnsDef}
            formatData={formatData}
            sorting={sort}
            onSortingChange={setSort}
            totalCount={totalCount || 0}
            pagination={pagination}
            onPaginationChange={setPagination}
            endpoint={endpoint}
            onExportAll={() =>
              exportAllDataLoader2<any>({
                endpoint,
                filter,
                sort,
                pageSize: 1000,
                fields,
              })
            }
          />
        </CatalogTableC>
    </>
  );
};

export default AreaOfPractice;
